/** Card per pagina su elenco medici (sito + area paziente). */
export const MEDICI_PAGE_SIZE = 12;

export function sortMediciByCognome(list) {
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => {
    const ca = (a?.cognome || a?.lastName || '').localeCompare(b?.cognome || b?.lastName || '', 'it', { sensitivity: 'base' });
    if (ca !== 0) return ca;
    return (a?.nome || a?.firstName || '').localeCompare(b?.nome || b?.firstName || '', 'it', { sensitivity: 'base' });
  });
}

export function paginateList(list, page, pageSize = MEDICI_PAGE_SIZE) {
  const safe = Array.isArray(list) ? list : [];
  const total = safe.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize) || 1);
  const current = Math.min(Math.max(1, page || 1), totalPages);
  const start = (current - 1) * pageSize;
  return {
    items: safe.slice(start, start + pageSize),
    page: current,
    totalPages,
    total,
    pageSize,
  };
}
